import React from 'react'
import styled from 'styled-components'

const Button = styled.button`
	color: var(--color-blue);

	&:hover {
		text-decoration: underline;
	}
`

const ShowMore = ({ onClick }) => <Button onClick={onClick}>Show More</Button>

export default ShowMore
